module.exports = "/assets/career/team/pawel.png?dHZvowY";